import { conversionRateBus } from "@/event/conversionRateBus"
import { formatCurrencyForLocale } from "@/event/locale"

export function convertPriceToEuroHappy(price: number | string) {
    const priceNumber = typeof price === 'string' ? Number(price) : price
    const convertedPrice = priceNumber * conversionRateBus.value

    return formatCurrencyForLocale(convertedPrice)
}
